import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { mobileQuery } from '../../utils/breakpoints';

export const StyledSmall = ({ text }) => (
  <small className="d-block d-sm-inline-block">{text}</small>
);

StyledSmall.propTypes = {
  text: PropTypes.string.isRequired,
};

export const StyledSmallDiv = styled.div`
  small {
    font-size: 20px;

    @media ${mobileQuery} {
      font-size: 16px;
    }
  }
`;
